import React from 'react';
import {
  DashboardOutlined,
  LockOutlined,
  UserOutlined,
  SettingOutlined,
  GlobalOutlined,
  ApartmentOutlined,
  BuildOutlined,
  ClockCircleOutlined,
  IdcardOutlined,
  MailOutlined,
  ApiOutlined,
  RobotOutlined,
  BarChartOutlined,
  SearchOutlined,
  FileOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { RouteConfig } from '../../types/route.types';
import userRoutes from '../../components/dashboard/admin/users/routes/user.route';
import roleRoutes from '../../components/dashboard/admin/roles/routes/role.route';
import countryRoutes from '../../components/dashboard/sysadmin/countries/routes/country.route';
import { sysAdminUserRoutes } from '../../components/dashboard/sysadmin/sysadmin-user/routes/sysadmin-user.route';
import { sysAdminRoleRoutes } from '../../components/dashboard/sysadmin/sysadmin-roles/routes/role.route';
import sysadminTenantRoutes from '@components/dashboard/sysadmin/sysadmin-tenant/routes/tenant.route';
import tenantRoutes from '@components/dashboard/admin/tenants/routes/tenant.route';
import { jobRoutes } from '@components/dashboard/admin/jobs/routes/job.route';
import visaApplicationRoutes from '@components/dashboard/admin/visa-applications/routes/visa-application.route';
import { emailConfigurationRoutes } from '@components/dashboard/sysadmin/emailConfigurations/routes/emailConfiguration.route';
import TenantGuard from '@components/common/TenantGuard';
import { workflowRoutes } from '@components/dashboard/admin/workflow/routes/workflow.route';
import botRoutes from '@components/dashboard/admin/bots/routes/bot.route';
import visaApplicationReportRoutes from '@components/dashboard/admin/reports/visa-application-report/routes/visa-application-report.route';
import userSearchRoutes from '@components/dashboard/admin/user-search/routes/user-search.route';
import visaApplicationAnalyticsRoutes from '@components/dashboard/admin/analytics/visa-application-analytics/routes/visa-application-analytics.route';
import mediaRoutes from '@components/dashboard/admin/media/routes/media.route';
import statusRoutes from '@components/dashboard/admin/statuses/routes/status.route';

export const dashboardRoutes: RouteConfig[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: <DashboardOutlined />,
    element: (
      <TenantGuard showHeader={true} headerTitle="Dashboard" showBreadcrumbs={true}>
        <div className="container mt-5">
          <h2>Welcome to Dashboard</h2>
          <p>Select a module from the menu to get started.</p>
        </div>
      </TenantGuard>
    ),
    index: true,
    children: [
      {
        key: 'dashboard/reports',
        label: 'Reports',
        path: '/dashboard/reports',
        icon: <BarChartOutlined />,
        routes: visaApplicationReportRoutes,
      },
      {
        key: 'dashboard/analytics',
        label: 'Analytics',
        path: '/dashboard/analytics',
        icon: <BarChartOutlined />,
        routes: visaApplicationAnalyticsRoutes,
      },
    ],
  },
  {
    key: 'admin',
    label: 'Admin',
    path: '/dashboard/admin',
    icon: <SettingOutlined />,
    requireSysAdmin: true,
    children: [
      {
        key: 'admin/user',
        label: 'Users',
        path: '/dashboard/admin/user',
        icon: <UserOutlined />,
        routes: sysAdminUserRoutes,
      },
      {
        key: 'admin/role',
        label: 'Roles',
        path: '/dashboard/admin/role',
        icon: <LockOutlined />,
        routes: sysAdminRoleRoutes,
      },
      {
        key: 'admin/country',
        label: 'Countries',
        path: '/dashboard/admin/country',
        icon: <GlobalOutlined />,
        routes: countryRoutes,
      },
      {
        key: 'admin/tenant',
        label: 'Tenants',
        path: '/dashboard/admin/tenant',
        icon: <ApartmentOutlined />,
        routes: sysadminTenantRoutes,
      },
      {
        key: 'admin/emailConfiguration',
        label: 'Email Configurations',
        path: '/dashboard/admin/emailConfiguration',
        icon: <MailOutlined />,
        routes: emailConfigurationRoutes,
      },
    ],
  },
  {
    key: 'search',
    label: 'Search',
    path: '/dashboard/search',
    icon: <SearchOutlined />,
    children: [
      {
        key: 'search/user-search',
        label: 'User Search',
        path: '/dashboard/search/user-search',
        icon: <UserOutlined />,
        routes: userSearchRoutes,
      },
    ],
  },
  {
    key: 'tenant',
    label: 'Tenant',
    path: '/dashboard/tenant',
    icon: <BuildOutlined />,
    routes: tenantRoutes,
  },
  {
    key: 'user',
    label: 'Users',
    path: '/dashboard/user',
    icon: <UserOutlined />,
    routes: userRoutes,
  },
  {
    key: 'role',
    label: 'Roles',
    path: '/dashboard/role',
    icon: <LockOutlined />,
    routes: roleRoutes,
  },
  {
    key: 'visa-application',
    label: 'Visa Applications',
    path: '/dashboard/visa-application',
    icon: <IdcardOutlined />,
    routes: visaApplicationRoutes,
  },
  {
    key: 'jobs',
    label: 'Jobs',
    path: '/dashboard/jobs',
    icon: <ClockCircleOutlined />,
    routes: jobRoutes,
  },
  {
    key: 'workflows',
    label: 'Workflows',
    path: '/dashboard/workflows',
    icon: <ApiOutlined />,
    routes: workflowRoutes,
  },
  {
    key: 'bots',
    label: 'Bots',
    path: '/dashboard/bots',
    icon: <RobotOutlined />,
    routes: botRoutes,
  },
  {
    key: 'file-manager',
    label: 'File Manager',
    path: '/dashboard/file-manager',
    icon: <FileOutlined />,
    routes: mediaRoutes,
  },
  {
    key: 'status',
    label: 'Statuses',
    path: '/dashboard/status',
    icon: <CheckCircleOutlined />,
    routes: statusRoutes,
  },
];
